import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import IconeJurisprudencia from '../img/icones/IconeJurisprudencia';
import RouterStore from '../store/RouterStore';
import Ambiente from '../utils/Ambiente';

interface IPropsJurisprudencia {

}


// @observer
export default class Jurisprudencia extends React.Component<IPropsJurisprudencia> {

    abrirJurisprudencia = () => {
        RouterStore.abrirJanela(Ambiente.urlJurisprudencia);
    }

    render() {
        return (
            <Tooltip title='Abrir Jurisprudência do TST'>
                <div>
                    <IconButton onClick={this.abrirJurisprudencia} aria-label='Abrir página de Jurisprudência do TST. Irá abrir em uma nova janela.'>
                        <IconeJurisprudencia />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }
}
